import { ITEM_DEFINITION_CODES } from '../../apps/angularjs/constants/item-definitions';
import { STATES } from '../../apps/angularjs/constants/states';
import {
  ITEM_STATUSES,
  ITEM_KINDS,
} from '../../apps/angularjs/constants/items';
import { intersection, findKey } from 'lodash-es';

export const statusFromItems = (items = []) => {
  return items
    .sort(({ statusUpdatedAt: a }, { statusUpdatedAt: b }) => (a > b ? 1 : -1))
    .map(item => ({
      ...item,
      status:
        item.status === ITEM_STATUSES.VALIDATING
          ? ITEM_STATUSES.PENDING
          : item.status,
    }))
    .reduce((result, { status, statusUpdatedAt }) => {
      if (
        status === ITEM_STATUSES.PENDING ||
        (status === ITEM_STATUSES.COMPLETED &&
          result.status !== ITEM_STATUSES.PENDING) ||
        [ITEM_STATUSES.PENDING, ITEM_STATUSES.COMPLETED].indexOf(
          result.status
        ) === -1
      ) {
        return { status, statusUpdatedAt };
      }

      return result;
    }, {});
};

export const currentStep = state => state?.currentStep;
export const isTerminalRoute = state => state?.isTerminalRoute;
export const nextSteps = session => {
  return orderedAvailableItemKinds(session);
};

export const nextStepsList = [
  ITEM_DEFINITION_CODES.HOME_SERVICE_APP,
  ITEM_DEFINITION_CODES.FORWARD_MAIL,
  ITEM_DEFINITION_CODES.PROMOTION,
  ITEM_DEFINITION_CODES.UTILITY,
  ITEM_DEFINITION_CODES.INSURANCE,
  ITEM_DEFINITION_CODES.MOVEIQ,
  ITEM_DEFINITION_CODES.SMART_HOME_OWN,
  ITEM_DEFINITION_CODES.UPDATE_ACCOUNT,
];

function orderedAvailableItemKinds({ items, itemDefinitions, currentMove }) {
  if (!itemDefinitions) return [];

  return itemDefinitions
    .map(({ code }) => code)
    .filter(code => nextStepsList.includes(code))
    .sort((a, b) =>
      nextStepsList.indexOf(a) > nextStepsList.indexOf(b) ? 1 : -1
    )
    .filter(isItemStillInDaisyChain({ items, currentMove }));
}

const isItemStillInDaisyChain = ({
  items,
  currentMove: { declined_item_types },
}) => code => {
  // Logic modeled off of logic in the dashboard see dashboard.component.js
  if (!items.find(({ kind }) => kind === code)) return true;
  if (
    declined_item_types &&
    findKey(declined_item_types, codes => codes.indexOf(code))
  )
    return false;

  const { status } = statusFromItems(items);
  return (
    status !== ITEM_STATUSES.COMPLETED &&
    status !== ITEM_STATUSES.PENDING &&
    status !== ITEM_STATUSES.VALIDATING &&
    status !== ITEM_STATUSES.CANCELLED &&
    status !== ITEM_STATUSES.RESERVED &&
    status !== ITEM_STATUSES.NOT_NEEDED &&
    status !== ITEM_STATUSES.CALLED
  );
};

export function deriveNextStep({ currentStep, filteredNextStepsList }) {
  if (filteredNextStepsList.length === 0) {
    return STATES.DASHBOARD;
  }

  // What's left of the static list
  let possibleRemainingSteps = nextStepsList.slice(
    nextStepsList.indexOf(currentStep) + 1
  );
  // What's left of that when filtered
  let actualRemainingSteps = intersection(
    possibleRemainingSteps,
    filteredNextStepsList
  );
  // The first remaining step will be the next step
  let nextStep = actualRemainingSteps[0];

  return nextStep || STATES.DASHBOARD;
}

export const routeFromStep = step => {
  // "New" steps are post-fixed with slashes else they dont match the state
  // "Older" steps do not need to have a slash at the end
  const stepToRouteMap = {
    [ITEM_KINDS.HOME_SERVICES_APP]: '/tv-internet/',
    [ITEM_KINDS.PROMOTION]: '/move-in-promotions/',
    [ITEM_KINDS.INSURANCE]: '/insurance/',
    [ITEM_KINDS.MOVEIQ]: '/book-your-move/',
    [ITEM_KINDS.FORWARD_MAIL]: '/forward-mail',
    [ITEM_KINDS.SMART_HOME_OWN]: '/smart-home',
    [ITEM_KINDS.UTILITY]: '/utilities',
    [ITEM_KINDS.UPDATE_ACCOUNT]: '/update-accounts',
  };
  return stepToRouteMap[step];
};
